import { render, staticRenderFns } from "./categoryInfo.vue?vue&type=template&id=2b8b07ac&"
import script from "./categoryInfo.vue?vue&type=script&lang=js&"
export * from "./categoryInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports